// @flow
import { createSelector } from 'reselect';
import find from 'ramda/es/find';


// $FlowFixMe
export default createSelector(
  [
    state => state.shop.order.deliveryPoints.currentDeliveryPointId,
    state => state.shop.order.deliveryPoints.data,
  ],
  (currentDeliveryPointId, data) => find(({ id }) => id === currentDeliveryPointId, data) || {},
);
